'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Style config
 *
 * This config mimics the style config from understyle, but a notable difference
 * is that we just use this config to construct classnames instead of the actual
 * style since we're using plain CSS.
 */
var defaultConfig = {
    colors: {
        black: 'black',
        cerulean: 'cerulean',
        white: 'white'
    },

    /**
     * Breakpoints represent the prefix to be applied for each breakpoint.  The
     * prefix will be applied as `${prefix}-${rule}`.  Note that this is
     * assuming a "mobile-first" approach.
     *
     * For example, this style prop would result in the following css rules
     * { display: ['block', 'flex', 'inline'] }
     * //=> 'display-block m-display-flex l-display-inline'
     *
     * The non-prefixed rule is meant to be applied up until the first
     * breakpoint, then the "m-" rule and then the "l-" rule.
     */
    breakpointPrefixes: ['m', 'l']
};

var Config = function () {
    function Config(config) {
        _classCallCheck(this, Config);

        this.value = _extends({}, config);
    }

    _createClass(Config, [{
        key: 'get',
        value: function get(key) {
            return this.value[key];
        }
    }, {
        key: 'set',
        value: function set(obj) {
            this.value = _extends({}, this.value, obj);

            return this.value;
        }
    }, {
        key: 'colors',
        get: function get() {
            return this.get('colors');
        }
    }, {
        key: 'breakpointPrefixes',
        get: function get() {
            return this.get('breakpointPrefixes');
        }
    }, {
        key: 'styles',
        get: function get() {
            return this.get('styles');
        }
    }]);

    return Config;
}();

var config = new Config(defaultConfig);

exports['default'] = config;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/config.js
 ** module id = 415
 ** module chunks = 0 1
 **/